const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.584,2.9A1.772,1.772,0,0,0,7.093.425L3.628,3.17a.51.51,0,0,0-.144.185L2.851,4.741a.25.25,0,0,1-.232.146,2.515,2.515,0,0,0-1.831.731c-.653.654-.724,2.8-.724,3.69a.625.625,0,0,0,.625.625c.891,0,3.036-.07,3.69-.724A2.518,2.518,0,0,0,5.11,7.38a.249.249,0,0,1,.147-.232l1.388-.631a.487.487,0,0,0,.186-.144ZM3.5,8.32a5.4,5.4,0,0,1-1.892.334.249.249,0,0,1-.265-.265A5.449,5.449,0,0,1,1.672,6.5,1.289,1.289,0,0,1,3.5,8.32Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
